import { AgGridReact } from 'ag-grid-react';
import { useMemo, useRef } from 'react';
import Header from '../../common/Header/Header';
import { Page, TableWrapper } from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';
import { useCoupons } from "../../services/coupon/coupon.service";
import { readOnlyLabelTableText } from '../../constants/GlobalTexts';
import { ITooltipParams } from 'ag-grid-community';

const Coupons = () => {
    const gridRef = useRef<AgGridReact>(null);
    const {data: couponsData, isError} = useCoupons();
    const coupons = couponsData?.data

    useFetchErrorToast([{isError, label: 'Error fetching Coupons', id: 'couponsFetchError'}]);
  const defaultColDef = useMemo(() => {
    return {
      // autoHeight: true, // Auto Height Cells
      // wrapHeaderText: true, // Wrap Header Text,
      // resizable: true
      initialWidth: 200,
      wrapHeaderText: false,
      autoHeaderHeight: true, // Changed from 200 to true
      resizable: true,
      tooltipValueGetter: (params: ITooltipParams) => params.value,
      filter: true,
      floatingFilter: true
    };
  }, []);

    return (
        <>
            <Header breadcrumb={{to: '/tables', label: 'All tables'}} title='Coupons' titleTestId={'CouponsPageTitle'}/>
            <Page>
                <TableWrapper>
                    <Table
                        rowData={coupons}
                        ref={gridRef}
                        height={'100%'}
                        returnedRecords={coupons?.length}
                        defaultColDef={defaultColDef}
                        readOnlyLabel={readOnlyLabelTableText}
                        columnDefs={[
                            {field: 'couponCode', headerName: 'Coupon Code' ,minWidth: 110},
                            { field: 'shortText', headerName: 'Short Text',tooltipValueGetter: (params) => params.value,minWidth: 120},
                            { field: 'mediumText', headerName: 'Medium Text',tooltipValueGetter: (params) => params.value,minWidth: 120},
                            { field: 'longText', headerName: 'Long Text',tooltipValueGetter: (params) => params.value,minWidth: 120},
                            { field: 'promoType', headerName: 'Promotion Type',minWidth: 120},
                            { field: 'appLevel', headerName: 'App Level',minWidth: 90},
                            { field: 'allowEdit', headerName: 'Allow Edit',minWidth: 90},
                            { field: 'ccp', headerName: 'CCP',minWidth: 70},
                            { field: 'inputRequired', headerName: 'Input Required',minWidth: 120},
                            { field: 'occasion', headerName: 'Occasion ID',minWidth: 100},
                            { field: 'startDate', headerName: 'Start Date',minWidth: 110},
                            { field: 'endDate', headerName: 'End Date',minWidth: 110},
                            { field: 'daysOfWeek', headerName: 'Days of Week',minWidth: 90},
                            { field: 'time', headerName: 'Time ID',minWidth: 70},
                            { field: 'sus', headerName: 'SUS',minWidth: 70},
                            { field: 'internet', headerName: 'Internet',minWidth: 80},
                            { field: 'overflow', headerName: 'Overflow',minWidth: 90},
                            { field: 'ivr', headerName: 'IVR',minWidth: 70},
                        ]}
                    />
                </TableWrapper>
            </Page>
        </>
    );
};

export default Coupons;
